<template>
  <div class="wrapper">
    <div class="main visual-2 /enter-phone visual-11">
      <Header :backRoute="'/'" />
      <div class="vis4-inr1">
        <h1>Enter Your Address</h1>
        <form
          class="namesearch"
          id="addressform"
          action="visual-12"
          method="get"
        >
          <div class="row">
            <div class="col-lg-8 col-md-8 col-sm-12">
              <label for="address">Street Address</label>
              <input
                type="text"
                id="addressone"
                name="street"
                placeholder="2718 Robert Road"
                required
              />
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
              <label for="city">City</label>
              <input
                type="text"
                id="addresstwo"
                name="city"
                placeholder="City"
                required
              />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-12">
              <label for="province">Province</label>
              <input
                type="text"
                id="addressthree"
                name="province"
                placeholder="Province"
                required
              />
            </div>
            <div class="col-lg-8 col-md-8 col-sm-12 add-col4">
              <label for="postal">Postal Code</label>
              <input
                type="text"
                id="addressfour"
                name="postal"
                placeholder="Postal Code"
                required
              />
              <button type="submit">Next</button>
            </div>
          </div>
        </form>
      </div>
      <div class="hlp-btn">
        <router-link to="/customer-support">
          <i class="fa-solid fa-circle-info"></i> Help
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/layout/Header.vue";
export default {
  components: {
    Header,
  },
  name: "VisualEleven",
};
</script>

<style scoped></style>
